import { HeadingTags, Region, TileLayout } from '@migros/msrc-articles';
import { SupportedLanguages } from '@migros/msrc-i18n';
import appConfig from 'helper/mapBackendConfig';

// shared config between different widget types i.e. product, slider...
// - disable _blank in the Android App, see https://jira.migros.net/browse/PULSAPP-668
const MsrcWidgetsSharedConfig = {
	apiUri: appConfig.env.msrc.api.uri,
	apiKey: appConfig.env.msrc.api.key,
	language: SupportedLanguages[appConfig.env.language],
	filterOptions: {
		fo: {
			anchor_target: '_self',
		},
		region: Region.national,
	},
};

export const ProductSliderWidgetConfig = {
	...MsrcWidgetsSharedConfig,
	theme: 'gesundheitsplattform',
	tilesVisibleCount: [2.5], // list layout per viewports
	disableLazyLoad: true,
};

export const ProductWidgetConfig = {
	...MsrcWidgetsSharedConfig,
	layout: TileLayout.mini,
	headingTagsLevel: HeadingTags.h2,
	trackingInfo: 'impuls-coach',
	hideRating: true,
};
